import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['tab', 'rangeTab']

  open(e) {
    e.preventDefault()
    this.popupTarget.classList.toggle('d-none')
  }

  async load(e) {
    e.preventDefault()
    window.dispatchEvent(new CustomEvent("reset-date-range"))

    this.setActive(e.currentTarget)
    await this.visit(e.currentTarget.dataset.url)
  }

  async range(from, to) {
    this.setActive(this.rangeTabTarget)
    await this.visit(`/wallets/transactions?filter=range&from=${from}&to=${to}`)
  }

  async visit(url) {
    const response = await fetch(url, {
      headers: {
        Accept: 'text/vnd.turbo-stream.html'
      }
    })

    Turbo.renderStreamMessage(await response.text())
  }

  
  setActive(activeTab) {
    const ACTIVE_CLASSES = ['text-white-border', 'gradient-bg-text']
    const INACTIVE_CLASS = 'text-tiffany-blue'
    this.tabTargets.forEach(tab => {
      if (tab === activeTab) {
        tab.classList.add(...ACTIVE_CLASSES)
        tab.classList.remove(INACTIVE_CLASS)
      } else {
        tab.classList.remove(...ACTIVE_CLASSES)
        tab.classList.add(INACTIVE_CLASS)
      }
    })
  }
}
